import { render, staticRenderFns } from "./Genshin.vue?vue&type=template&id=6988bd83&"
import script from "./Genshin.vue?vue&type=script&lang=js&"
export * from "./Genshin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports